import { BaseService, Service } from "/@/cool";

@Service("ossArchive")
class OssArchiveService extends BaseService {
	declare namespace?: string;

	constructor() {
		super();

		const prefix = this.namespace ? this.namespace.replace(/\//g, ":") + ":" : "";
		this.permission["restoreApply"] = prefix + "restoreApply";
		this.permission["restoreInfo"] = prefix + "restoreInfo";
		this.permission["getConfig"] = prefix + "getConfig";
		this.permission["getConfigSchema"] = prefix + "getConfigSchema";
		this.permission["saveConfig"] = prefix + "saveConfig";
		this.permission["resetConfig"] = prefix + "resetConfig";
		this.permission["overview"] = prefix + "overview";
		this.permission["prefixReport"] = prefix + "prefixReport";
		this.permission["freezeDryRun"] = prefix + "freezeDryRun";
		this.permission["freezeRun"] = prefix + "freezeRun";
		this.permission["restoreMonitor"] = prefix + "restoreMonitor";
		this.permission["restoreRetry"] = prefix + "restoreRetry";
		this.permission["debugSimulateRead"] = prefix + "debugSimulateRead";
		this.permission["debugInspectObject"] = prefix + "debugInspectObject";
		this.permission["debugForceRestoreApply"] = prefix + "debugForceRestoreApply";
		this.permission["debugColdeupRun"] = prefix + "debugColdeupRun";
	}

	restoreApply(data: Record<string, any>) {
		return this.request({
			url: "/restoreApply",
			method: "POST",
			data: {
				source: "repair",
				...data
			}
		});
	}

	restoreInfo(params: { pid: number | string }) {
		return this.request({
			url: "/restoreInfo",
			method: "GET",
			params
		});
	}

	getConfig() {
		return this.request({
			url: "/getConfig",
			method: "GET"
		});
	}

	getConfigSchema() {
		return this.request({
			url: "/getConfigSchema",
			method: "GET"
		});
	}

	saveConfig(data: Record<string, any>) {
		return this.request({
			url: "/saveConfig",
			method: "POST",
			data
		});
	}

	resetConfig() {
		return this.request({
			url: "/resetConfig",
			method: "POST"
		});
	}

	overview() {
		return this.request({
			url: "/overview",
			method: "GET"
		});
	}

	prefixReport() {
		return this.request({
			url: "/prefixReport",
			method: "GET"
		});
	}

	freezeDryRun(data: Record<string, any>) {
		return this.request({
			url: "/freezeDryRun",
			method: "POST",
			data
		});
	}

	freezeRun(data: Record<string, any>) {
		return this.request({
			url: "/freezeRun",
			method: "POST",
			data
		});
	}

	restoreMonitor(data?: Record<string, any>) {
		return this.request({
			url: "/restoreMonitor",
			method: "POST",
			data: data || {}
		});
	}

	restoreRetry(params: { task_id?: number | string; pid?: number | string }) {
		return this.request({
			url: "/restoreRetry",
			method: "POST",
			params
		});
	}

	debugSimulateRead(data: Record<string, any>) {
		return this.request({
			url: "/debugSimulateRead",
			method: "POST",
			data
		});
	}

	debugInspectObject(data: {
		key: string;
		bucket?: string;
		access_key_id?: string;
		access_key_secret?: string;
		endpoint?: string;
	}) {
		return this.request({
			url: "/debugInspectObject",
			method: "POST",
			data
		});
	}

	debugForceRestoreApply(data: {
		key?: string;
		object_key?: string;
		bucket?: string;
		access_key_id?: string;
		access_key_secret?: string;
		endpoint?: string;
	}) {
		return this.request({
			url: "/debugForceRestoreApply",
			method: "POST",
			data
		});
	}

	debugColdeupRun(data: Record<string, any>) {
		return this.request({
			url: "/debugColdeupRun",
			method: "POST",
			data
		});
	}
}

export default OssArchiveService;
